import React from 'react';
import LoadingAnimation from './LoadingAnimation';

interface SessionLoadingScreenProps {}

const SessionLoadingScreen: React.FC<SessionLoadingScreenProps> = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#f0f2f5',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 9999,
    }}>
      <LoadingAnimation />
      <p style={{
        marginTop: '20px',
        fontSize: '1.2rem',
        color: '#606770',
      }}>Preparing your session...</p>
    </div>
  );
};

export default SessionLoadingScreen;